import {
  AreaData,
  createLocationDisplayList,
} from 'logics/createLocationInitialList';
import { useState, ChangeEvent } from 'react';

/**
 * 勤務地に関するhooks
 * @param locationInitialList
 * @returns 勤務地の値と更新する関数を含むオブジェクト
 */
export const useLocation = (locationInitialList: AreaData[]) => {
  const [locationDisplayList, setLocationDisplayList] =
    useState<AreaData[]>(locationInitialList);
  const areaList = locationDisplayList;
  const prefectureList = locationDisplayList.flatMap(
    (prefecture) => prefecture.prefectureList
  );
  const cityList = locationDisplayList.flatMap((prefecture) =>
    prefecture.prefectureList.flatMap((city) => city.cityList)
  );
  const wardList = locationDisplayList.flatMap((prefecture) =>
    prefecture.prefectureList
      .flatMap((city) => city.cityList)
      .flatMap((ward) => ward.wardList)
  );

  // 選択中の地域のid配列
  const selectedAreaIdList = areaList
    .filter(({ isChecked }) => isChecked)
    .map(({ id }) => id);

  // 選択中の都道府県のid配列
  const selectedPrefectureIdList = prefectureList
    .filter(({ isChecked }) => isChecked)
    .map(({ id }) => id);

  // 選択中の市区町村のid配列
  const selectedCityIdList = cityList
    .filter(({ isChecked }) => isChecked)
    .map(({ id }) => id);

  // 選択中の政令指定都市のid配列
  const selectedWardList = wardList
    .filter(({ isChecked }) => isChecked)
    .map(({ id }) => id);

  // 地域のチェックボックス更新処理
  const updateIsCheckedAreaList = (
    event: ChangeEvent<HTMLInputElement>,
    selectedId: string
  ) => {
    const checkedList = areaList.map((area) => {
      if (area.id !== selectedId) return area;
      return {
        ...area,
        isChecked: event.target.checked,
      };
    });

    const checkedLocationDisplayList: AreaData[] = createLocationDisplayList({
      areaList: checkedList,
      prefectureList,
      cityList,
      wardList,
    });
    setLocationDisplayList(checkedLocationDisplayList);

    return checkedList.filter(({ isChecked }) => isChecked).map(({ id }) => id);
  };

  // 都道府県のチェックボックス更新処理
  const updateIsCheckedPrefectureList = (
    event: ChangeEvent<HTMLInputElement>,
    selectedId: string
  ) => {
    const checkedList = prefectureList.map((area) => {
      if (area.id !== selectedId) return area;
      return {
        ...area,
        isChecked: event.target.checked,
      };
    });

    const checkedLocationDisplayList: AreaData[] = createLocationDisplayList({
      areaList,
      prefectureList: checkedList,
      cityList,
      wardList,
    });
    setLocationDisplayList(checkedLocationDisplayList);

    return checkedList.filter(({ isChecked }) => isChecked).map(({ id }) => id);
  };

  // 市区町村のチェックボックス更新処理
  const updateIsCheckedCityList = (
    event: ChangeEvent<HTMLInputElement>,
    selectedId: string
  ) => {
    const checkedList = cityList.map((area) => {
      if (area.id !== selectedId) return area;
      return {
        ...area,
        isChecked: event.target.checked,
      };
    });

    const checkedLocationDisplayList: AreaData[] = createLocationDisplayList({
      areaList,
      prefectureList,
      cityList: checkedList,
      wardList,
    });
    setLocationDisplayList(checkedLocationDisplayList);

    return checkedList.filter(({ isChecked }) => isChecked).map(({ id }) => id);
  };

  // 政令指定都市のチェックボックス更新処理
  const updateIsCheckedWardList = (
    event: ChangeEvent<HTMLInputElement>,
    selectedId: string
  ) => {
    const checkedList = wardList.map((area) => {
      if (area.id !== selectedId) return area;
      return {
        ...area,
        isChecked: event.target.checked,
      };
    });

    const checkedLocationDisplayList: AreaData[] = createLocationDisplayList({
      areaList,
      prefectureList,
      cityList,
      wardList: checkedList,
    });
    setLocationDisplayList(checkedLocationDisplayList);

    return checkedList.filter(({ isChecked }) => isChecked).map(({ id }) => id);
  };

  // チェック状態クリア処理
  const clearIsCheckLocationList = () => {
    setLocationDisplayList([]);
  };

  return {
    setLocationDisplayList,
    locationDisplayList,
    selectedAreaIdList,
    selectedPrefectureIdList,
    selectedCityIdList,
    selectedWardList,
    clearIsCheckLocationList,
    updateLocationFunctions: {
      updateIsCheckedAreaList,
      updateIsCheckedPrefectureList,
      updateIsCheckedCityList,
      updateIsCheckedWardList,
    },
  };
};
